import { Checkbox, type CheckboxProps } from "@mantine/core";

import styles from "./ChecklistCheckbox.module.scss";

export const ChecklistCheckbox = ({
  className,
  variant,
  ...props
}: CheckboxProps & { variant?: "default" | "na" }) => (
  <Checkbox
    className={`${styles.checkbox} ${variant === "na" ? styles.checkboxNa : ""} ${className ?? ""}`}
    {...props}
  />
);
